export default "__VITE_ASSET__C1CyLeRd__"